module.exports = __webpack_public_path__ + "media/assets/images/votorantim-energia@3x-15559c3d39a645aace662330420b9741.png";